// Scene imagery (generated environments — contain NO M1 PRO product).
// Homepage hero artwork lives in data/heroArtwork.ts.

export const sceneImages = {
  heroPool:
    'https://cdn.magicpatterns.com/patterns/generated-images/b65bad62-57fc-4de3-b1dc-433172ede008.jpg',
  heroPoolPrevious:
    'https://cdn.magicpatterns.com/patterns/generated-images/08b1f703-c293-480a-a6a0-f9ae3f384aa0.jpg',
  spa: 'https://cdn.magicpatterns.com/patterns/generated-images/e5af46b5-f95a-4152-aee8-38f8484268dd.jpg',
  mediumPool:
    'https://cdn.magicpatterns.com/patterns/generated-images/fda3591c-fd7c-4274-bde8-a55f990b0973.jpg',
  poolSteps:
    'https://cdn.magicpatterns.com/patterns/generated-images/0430d92b-7640-4e22-ad8a-46a70d5430e9.jpg',
  waterTexture:
    'https://cdn.magicpatterns.com/patterns/generated-images/a9cc01d7-a5bd-4f08-9c1c-fbb5d9cf3781.jpg',
};

// ─────────────────────────────────────────────────────────────
// VERIFIED PRODUCT ASSETS — authentic manufacturer photographs ONLY.
// An asset renders on the site only when BOTH `src` is set AND
// `ledCountVerified` is true (all 13 lenses counted against the
// reference arrangement below). Never substitute generated imagery.
// ─────────────────────────────────────────────────────────────

export type ProductView = 'front' | 'side' | 'rear' | 'mount' | 'lit' | 'packaging' | 'exploded';

export type ProductAsset = {
  src: string;
  ledCountVerified: boolean;
  verificationNotes: string;
};

const pending = (): ProductAsset => ({ src: '', ledCountVerified: false, verificationNotes: '' });

export const productAssets: Record<ProductView, ProductAsset> = {
  front: pending(),
  side: pending(),
  rear: pending(),
  mount: pending(),
  lit: pending(),
  packaging: pending(),
  exploded: pending(),
};

/** Verified manufacturer frontal arrangement (top → bottom). */
export const referenceLedArrangement = {
  rows: [1, 3, 5, 3, 1],
  total: 13,
  description: '1 upper · 3 upper-inner · 5 central · 3 lower-inner · 1 bottom',
};

export const productViewLabels: Record<ProductView, string> = {
  front: 'Front view · 13 LED lenses',
  side: 'Side profile · 1.2 in thickness',
  rear: 'Rear · blue power button + USB-C cover',
  mount: 'Magnetic Mount System base',
  lit: 'Illuminated · electric blue',
  packaging: 'Approved premium packaging',
  exploded: 'Light above magnetic base',
};

// Approved brand assets — supply official files. Wordmark falls back to type.
export const brandAssets = {
  crest: '',
  wordmark: '',
};
